//console.log("check11")
$(document).ready(function(){
  let chekDiv= document.createElement("div")
  chekDiv.classList.add("checkDiv")
  document.body.append(chekDiv)
  
a=document.querySelectorAll(".main-product-grid")
var mySet = new Set(); //here all tags from barcodes
a.forEach(x=>{
c=x.getAttribute("data-value").split("|")

c.forEach(y=>{
  if(y.lastIndexOf("Color_")<2){
		mySet.add(y)	//here we add unic tags from barcodes
}
})
})


var setOfAllTags = new Set(); //here all tags from  tags of every product
a.forEach(x=>{
c=x.getAttribute("data-tags").split("|")  //Characteristics
c.forEach(y=>{
setOfAllTags.add(y.trim())	//here we add unic tags from tags of every product
})
})

console.log(mySet)




 
 

/////// Color filter settings


$(".ColorSwatchList").empty()
 
setOfColors=new Set()
let ColorFilterNames = mySet.forEach(btn=>{
		if(btn.includes("Color_")){
          console.log("btn",btn)
		getColor=btn.trim().split("Color_")
		getColor.forEach(getColorName=>{
				if(getColorName.length>1){
					setOfColors.add(getColorName.trim())

					ColorSwatchList=document.querySelector(".ColorSwatchList")
					liswat=document.createElement("li")
					ColorSwatchList.append(liswat)
					liswat.classList.add("HorizontalList__Item")
					btns=document.createElement("button")
					

					 btns.classList.add("filters_tag")
					 btns.classList.add("ColorSwatch")
					  btns.setAttribute("data-tooltip", getColorName.trim())
					  btns.style.backgroundColor=getColorName.trim()
					 liswat.append(btns)
					

				}
		})
		

		}
})




let selectedfilter={}

$(".filters_tag.ColorSwatch").click(function(){
  $(".filters_tag.ColorSwatch.is-active").removeClass("is-active")
  $(this).addClass("is-active")
	selectedfilter.color=$(this).data("tooltip")
	//console.log(selectedfilter)
})



///////////////// Characteristics &Type filtering

$("#Product_tag_1 .Linklist").empty()  // it ok, it must here
setOfCharacteristics=new Set()
let CharacteristicsFilterNames = setOfAllTags.forEach(btn=>{
		if(btn.includes("Characteristics_")){
		getCharacteristics=btn.trim().split("Characteristics_")
		getCharacteristics.forEach(getCharacteristicsName=>{
				if(getCharacteristicsName.length>1){
					setOfCharacteristics.add(getCharacteristicsName.trim())

					CharacteristicsLinklist=document.querySelector("#Product_tag_1 .Linklist")
					liswatn=document.createElement("li")
				
					liswatn.classList.add("Linklist__Item")
					liswatn.classList.add("filters_tag")

					CharacteristicsLinklist.append(liswatn)
					btnsC=document.createElement("button")
					 btnsC.classList.add("Text--subdued")
					 btnsC.classList.add("Link")
					 btnsC.classList.add("Link--primary")
                     btnsC.classList.add("CharacteristicTumblr")
					  btnsC.setAttribute("data-characteristic", getCharacteristicsName.trim())
					  btnsC.innerHTML=getCharacteristicsName.trim()
					 liswatn.append(btnsC)
					

				}
		})
		

		}
})


$(".CharacteristicTumblr").click(function(){
   
	selectedfilter.characteristic=$(this).data("characteristic")
	//console.log(selectedfilter)
})



if(document.querySelector("#Product_tag_3 .Linklist"))
{
  $("#Product_tag_3 .Linklist").empty() // it ok, it must here
    setOfTypes=new Set()
    let TypesFilterNames = setOfAllTags.forEach(btn=>{
            if(btn.includes("Type_")){
            getTypes=btn.trim().split("Type_")
            getTypes.forEach(getTypesName=>{
                    if(getTypesName.length>1){
                        setOfTypes.add(getTypesName.trim())

                        TypesLinklist=document.querySelector("#Product_tag_3 .Linklist")
                        liswatn=document.createElement("li")

                        liswatn.classList.add("Linklist__Item")
                        liswatn.classList.add("filters_tag")

                        TypesLinklist.append(liswatn)
                        btnsC=document.createElement("button")
                         btnsC.classList.add("Text--subdued")
                         btnsC.classList.add("Link")
                         btnsC.classList.add("Link--primary")
                         btnsC.classList.add("TypesTumblr")
                          btnsC.setAttribute("data-types", getTypesName.trim())
                          btnsC.innerHTML=getTypesName.trim()
                         liswatn.append(btnsC)


                    }
            })


            }
    })
 }

$(".TypesTumblr").click(function(){
  
	selectedfilter.type=$(this).data("types")
	//console.log(selectedfilter)
})

$("#Product_tag_3 .Linklist__Item").click(function(){
  $("#Product_tag_3 .Linklist__Item.is-selected").removeClass("is-selected")
 $(this).addClass("is-selected")
 
  btnsC.classList.add("Link--primary")
 //console.log("test1")
})

$("#Product_tag_1 .Linklist__Item").click(function(){
  $("#Product_tag_1 .Linklist__Item.is-selected").removeClass("is-selected")
 $(this).addClass("is-selected")
 
  btnsC.classList.add("Link--primary")
 //console.log("test1")
})





$(".CollectionMain button[data-action=open-drawer]").click(function(){
//selectedfilter={}
//$(".filters_tag.ColorSwatch.is-active").removeClass("is-active")
//$(".Linklist__Item.is-selected").removeClass("is-selected")
//console.log(selectedfilter)
})



$("button[data-action=apply-tags]").attr("data-getfiltered", "true")
$("button[data-action=apply-tags]").removeAttr("data-action")

$("button[data-action=reset-tags]").attr("data-rsetFilters", "true")
$("button[data-action=reset-tags]").removeAttr("data-action")
$("button[data-rsetFilters=true]").show()



$("button[data-rsetFilters=true]").click(function(){
  $(".countFill").empty()
   $('.Drawer__Close').click();
selectedfilter={}
$(".filters_tag.ColorSwatch.is-active").removeClass("is-active")
$(".Linklist__Item.is-selected").removeClass("is-selected")
//console.log(selectedfilter)

a.forEach(select=>{
  select.style.display="block"})


})




$("button[data-getfiltered=true]").click(function(){  //click on apply btn
//   if( document.querySelector(".countFill")){
//   document.querySelector(".countFill").innerHTML=""
//   }
  
   $(".countFill").empty()
  $(".CollectionMain button[data-action=open-drawer]").append("<span class='countFill'>("+Object.keys(selectedfilter).length+")</span>")
  
   selectedfilterMain=[]
  
    if(selectedfilter.color){
    	selectedfilterMain["color"]="Color_"+selectedfilter.color
        
    }
  
  if(selectedfilter.characteristic){
    	selectedfilterMain["characteristic"]="Characteristics_"+selectedfilter.characteristic
      
  }
  
  if(selectedfilter.type){
    	selectedfilterMain["type"]="Type_"+selectedfilter.type
   
  }
  
  console.log(selectedfilterMain.length)
   NumberSelected=selectedfilterMain.length
   
   NumberGoodCandidates=0	
 $('.Drawer__Close').click();
   a.forEach(select=>{
     
		select.style.display="none"
			c=select.getAttribute("data-value").split("|") //get all tags from barcodes of each variant
            c1=select.getAttribute("data-tags").split("|") //get all tags from tags of each product
              //console.log("step get attr")
            if(selectedfilter.color){
              //console.log("step check collor check")
            		c.forEach(check=>{
                      //console.log("step start search a color", check)
					if(check==selectedfilterMain["color"]){
							//console.log("found1")
							//select.style.display="block"
                            
                            if(selectedfilter.characteristic){
                              //console.log("step check characteristic check")
                            		    c1.forEach(checkg=>{
                                          
                                                  if(checkg.trim()==selectedfilterMain["characteristic"]){
                                                          //console.log("found2")
                                                        //  select.style.display="block"
                                                          
                                                            if(selectedfilter.type){
                                                                      c1.forEach(checkgtyp=>{
                                                                         //console.log("step start search a characteristic")
                                                                         //console.log("checkg:'"+checkgtyp+"'")
                                                                         //console.log("type'"+selectedfilterMain["type"]+"'")
                                                                        
                                                                                if(checkgtyp.trim()==selectedfilterMain["type"]){
                                                                                        //console.log("found3")
                                                                                        select.style.display="block"
                                                                                }
                                                                        })
                                                          }else{
                                                              select.style.display="block"
                                                          }
                                                          
                                                          
                                                  }
                                          })
                            }else{
                            	select.style.display="block"
                            }
                            
                            
					}
					})
            } else  if(selectedfilter.characteristic){
                            		 
                            		    c1.forEach(checkg=>{
                                          
                                                  if(checkg.trim()==selectedfilterMain["characteristic"]){
                                                          //console.log("found2")
                                                        //  select.style.display="block"
                                                          
                                                            if(selectedfilter.type){
                                                                      c1.forEach(checkgtyp=>{
                                                                         
                                                                        
                                                                                if(checkgtyp.trim()==selectedfilterMain["type"]){
                                                                                        //console.log("found3")
                                                                                        select.style.display="block"
                                                                                }
                                                                        })
                                                          }else{
                                                              select.style.display="block"
                                                          }
                                                          
                                                          
                                                  }
                                          })
              }else  if(selectedfilter.type){
                                                                       c1.forEach(checkgtyp=>{
                                                                          //console.log("step start search a type")
                                                                         //console.log("checkg:'"+checkgtyp+"'")
                                                                         //console.log("type'"+selectedfilterMain["type"]+"'")
                                                                        
                                                                                if(checkgtyp.trim()==selectedfilterMain["type"]){
                                                                                        //console.log("found3")
                                                                                        select.style.display="block"
                                                                                }
                                                                        })
              }else{
              			select.style.display="block"		
              }
     
     
     			
            
			
            
            
            
            
            })
  
  
 
	 


})





})